export class UpdateGroupDto {
    autoGenerateGoals: boolean;
    id: number;
    date: string;
}
